import React, { Component } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// Open Maps
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'

const Image = (props) => {

    if (!props.image_thumb) return '';

    return (
        <div className="image">

            <img src={props.image_thumb} alt={props.title} />

        </div>
    )
}

// Details
const TCCActiveGroup = (props) => {

    if (!props.group) return (
        <div className={"TCCActiveGroup " + props.open}></div>
    );

    const target = (props.group.Location) ? '_blank' : '';
    return (

        <div className={"TCCActiveGroup " + props.open} style={{ 'zIndex': '1000' }}>

            <button onClick={() => props.close()} className="close"><span className="icon icon-cancel"></span></button>

            <div className="group-details">

                <Image {...props.group} />

                <h6 className="title" dangerouslySetInnerHTML={{ __html: props.group.title }}></h6>

                <div className="when" dangerouslySetInnerHTML={{ __html: props.group.when }}></div>

                <div className="time" dangerouslySetInnerHTML={{ __html: props.group.time }}></div>

                <div className="area" dangerouslySetInnerHTML={{ __html: props.group.address.address }}></div>

            </div>

            <a href={props.group.url} target={target} className="button">View More</a>

        </div>

    )

}

class TCCGroupsOpenMap extends Component {


    constructor(props) {
        super(props);


        this.state = {
            center: {
                lat: 40.730610,
                lng: -73.935242
            },
            zoom: (this.props.zoom) ? this.props.zoom : 11,
            activeIndex: null,
            activeGroup: null,
        }

    }

    componentDidMount() {



        if (this.props.geolocate === true) {
            this.geolocate();
        } else {
            this.getDefaultLocation();
        }

    }

    geolocate() {
        // TODO:
    }

    getDefaultLocation() {

        if (!this.props.center) return this.state.center;

        this.setState({
            center: {
                lat: parseFloat(this.props.center.lat),
                lng: parseFloat(this.props.center.lng)
            }
        })

    }
    returnDefaultLocation() {

        if (!this.props.center) return this.state.center;

        return {

            lat: parseFloat(this.props.center.lat),
            lng: parseFloat(this.props.center.lng)

        }

    }



    setActiveGroup(id) {

        const groups = this.props.groups.filter(g => g.ID === id)

        this.setState({
            activeIndex: id,
            activeGroup: groups[0]
        });

    }

    handleMarkerClick(e) {
        this.setActiveGroup(e);
    }

    handleCloseDetails() {
        this.setState({ activeIndex: null });
    }

    renderMarkers() {
        return this.props.groups.map(item => {
            //   let item = this.props.groups[key];


            if (!item.address) return;
            if (item.address_settings != "show") return;
            if (!item.address.lat) return;
            if (!item.address.lng) return;

            let position = {
                lat: parseFloat(item.address.lat),
                lng: parseFloat(item.address.lng)
            }

            return (
                <Marker
                    position={position}
                    key={item.ID}
                    {...item}
                    onClick={() => this.handleMarkerClick(item.ID)}>
                </Marker>
            );
        })
    }


    // Inline Popup
    // <Popup>
    //   {item.title}
    // </Popup>


    render() {
        return (
            <div style={{ height: '400px' }}>

                <Map center={this.returnDefaultLocation()} zoom={this.state.zoom} style={{ height: '100%' }}>
                    <TileLayer
                        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"
                    />

                    {this.renderMarkers()}

                </Map>

                <TCCActiveGroup open={(this.state.activeIndex) ? '-open' : '-close'} group={this.state.activeGroup} close={(e) => this.handleCloseDetails(e)} />

            </div>
        );
    }
}

export default TCCGroupsOpenMap;
